// Length helpers for rich-text (Quill) content.
// Callers pass either Quill's plain text (editor.getText()) or a stored HTML
// value, so both inputs are normalised to plain text before counting.

const toPlainText = (input = '') => {
    if (typeof input !== 'string') return '';
    return input
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim();
};

export const countRichTextCharacters = (input = '') => toPlainText(input).length;

export const countRichTextWords = (input = '') => {
    const text = toPlainText(input);
    return text ? text.split(' ').length : 0;
};
